export default __webpack_public_path__ + "static/media/highlight_off.a6988a22.svg";